import { endPoints } from "@/constants/apiSetting";
import httpClient from "@/common/service/HttpClient";
import SweetAlertService from "./SweetAlertService";
const PayrollAdjustmentService = {
  async getPayAdjList(obj) {
    const response = await httpClient.post(
      endPoints.getPayrollAdjustmentList,
      obj
    );
    if (response.data.IsSuccess) {
      return Promise.resolve(response);
    } else {
      SweetAlertService.warning("Warn", response.data.Message);
      return Promise.reject([]);
    }
  },
  async importPayAdjList(obj) {
    const response = await httpClient.post(
      endPoints.importPayrollAdjustmentList,
      obj
    );
    if (response.data.IsSuccess) {
      SweetAlertService.success("Success", response.data.Message);
      return Promise.resolve(response);
    } else {
      SweetAlertService.warning("Warn", response.data.Message);
      return Promise.reject([]);
    }
  },
  async savePayAdj(obj) {
    const response = await httpClient.post(
      endPoints.savePayrollAdjustment,
      obj
    );
    if (response.data.IsSuccess) {
      SweetAlertService.success("Success", response.data.Message);
      return Promise.resolve(response);
    } else {
      SweetAlertService.warning("Warn", response.data.Message);
      return Promise.reject([]);
    }
  },
  async deletePayAdj(obj) {
    const response = await httpClient.post(
      endPoints.deletePayrollAdjustment,
      obj
    );
    if (response.data.IsSuccess) {
      SweetAlertService.success("Success", response.data.Message);
      return Promise.resolve(response);
    } else {
      SweetAlertService.warning("Warn", response.data.Message);
      return Promise.reject([]);
    }
  },
  async getIncTypeList(obj) {
    const response = await httpClient.post(endPoints.getIncTypes, obj);
    if (response.data.IsSuccess) {
      return Promise.resolve(response);
    } else {
      SweetAlertService.warning("Warn", response.data.Message);
      return Promise.reject([]);
    }
  },
  async saveIncType(obj) {
    const response = await httpClient.post(endPoints.saveIncType, obj);
    if (response.data.IsSuccess) {
      SweetAlertService.success("Success", response.data.Message);
      return Promise.resolve(response);
    } else {
      SweetAlertService.warning("Warn", response.data.Message);
      return Promise.reject([]);
    }
  },
  async deleteIncType(obj) {
    const response = await httpClient.post(endPoints.deleteIncType, obj);
    if (response.data.IsSuccess) {
      SweetAlertService.success("Success", response.data.Message);
      return Promise.resolve(response);
    } else {
      SweetAlertService.warning("Warn", response.data.Message);
      return Promise.reject([]);
    }
  }
};
export default PayrollAdjustmentService;



// WEBPACK FOOTER //
// ./src/service/PayrollAdjustmentService.js